export default __webpack_public_path__ + "static/1-6-0-0-d937c240397a4496a7931ca68bb07c6d.jpg";